import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navigation from './component/Nav.jsx';
import Footer from './component/Footer.jsx';
import Home from './component/Home.jsx';
import AboutUs from './component/AboutUs.jsx';
import WhoWeAre from './component/WhoWeAre.jsx';
import HowWeDoIt from './component/HowWeDoIt.jsx';
import Gallery from './component/Gallery.jsx';  // Import the new Gallery component
import Blog from './component/Blog.jsx';
import ContactUs from './component/ContactUs.jsx';
import DonateNow from './component/DonateNow.jsx';
import 'bootstrap/dist/css/bootstrap.min.css';
import './style/Nav.css';


function App() {
  return (
    <Router>
      <Navigation className="mb-5" />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/who-we-are" element={<WhoWeAre />} />
        <Route path="/how-we-do-it" element={<HowWeDoIt />} />
        <Route path="/gallery" element={<Gallery />} />  {/* Added Gallery route */}
        <Route path="/blog" element={<Blog />} /> 
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/donate-now" element={<DonateNow />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
